// extracted by mini-css-extract-plugin
module.exports = {"item":"RoomCapacityItem-module--item--bX54k","title":"RoomCapacityItem-module--title--3kWVa","values":"RoomCapacityItem-module--values--3OLcI"};